export default "__VITE_ASSET__DH5U_6Ay__"